import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { FranchiseNotification } from '../pages/bets/types/betListTypes';

interface FranchiseNotificationState {
  franchiseNotifications: FranchiseNotification[];
  selectedNotifcationTypes: number[];
}

const initialState: FranchiseNotificationState = {
  franchiseNotifications: [],
  selectedNotifcationTypes: [],
};

export const franchiseNotifcationsSlice = createSlice({
  name: 'franchiseNotifcations',
  initialState,
  reducers: {
    setFranchiseNotifications: (
      state: FranchiseNotificationState,
      action: PayloadAction<FranchiseNotification[]>,
    ) => {
      state.franchiseNotifications = action.payload;
    },
    addFranchiseNotification: (
      state: FranchiseNotificationState,
      action: PayloadAction<FranchiseNotification>,
    ) => {
      state.franchiseNotifications = [action.payload, ...state.franchiseNotifications];
    },
    removeFranchiseNotification: (
      state: FranchiseNotificationState,
      action: PayloadAction<{
            Id: number
        }>,
    ) => {
      const newNotifications = state.franchiseNotifications.filter((br) => br.Id !== action.payload.Id);
      state.franchiseNotifications = newNotifications;
    },
    setSelectedNotificaitonTypes: (
      state: FranchiseNotificationState,
      action: PayloadAction<number[]>,
    ) => {
      state.selectedNotifcationTypes = action.payload;
    },
  },
});

export const {
  setFranchiseNotifications,
  addFranchiseNotification,
  removeFranchiseNotification,
  setSelectedNotificaitonTypes,
} = franchiseNotifcationsSlice.actions;

export default franchiseNotifcationsSlice.reducer;
